export default __webpack_public_path__ + "static/media/thunder-logo.ebfcbb30.svg";